import restaurantInstance from '../instance'

const confirmWaiterCall = (publicId) => {
  return restaurantInstance.post(`tables/${publicId}/waiterCalls/confirm`)
}

export default confirmWaiterCall